import { useQuery } from '@tanstack/react-query';
import { Navigate, useLocation } from 'react-router-dom';
import { api } from '@/shared/api/api';
import type { User } from '@/shared/types/user';
import { Spinner } from '@/shared/ui';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();

  const {
    data: user,
    isLoading,
    error,
  } = useQuery<Omit<User, 'is_confirmed'>, Error>({
    queryKey: ['user', 'auth-check'],
    queryFn: async () => await api.get<Omit<User, 'is_confirmed'>>('users/me'),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  // 로딩 중
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  // 인증되지 않음
  if (!user || error) {
    return (
      <Navigate
        replace
        state={{ from: location.pathname }}
        to="/signin"
      />
    );
  }

  return <>{children}</>;
}
